import { Dialog } from '@headlessui/react'
import { CogIcon } from '@heroicons/react/outline'
import { MiniGrid } from '../mini-grid/MiniGrid'
import { shareStatus } from '../../lib/share'
import { BaseModal } from './BaseModal'
import { NextWirdCountdown } from '../misc/NextWirdCountdown'
import { ShowMeaning } from '../misc/ShowMeaning'
import { SHARE_TEXT, SUPPORT_US_TEXT } from '../../constants/strings'

type Props = {
  isOpen: boolean
  handleClose: () => void
  guesses: string[]
  isHardMode: boolean
  handleShare: () => void
}

export const WinModal = ({
  isOpen,
  handleClose,
  guesses,
  isHardMode,
  handleShare,
}: Props) => {
  let hardmodePrompt
  if (!isHardMode) {
    hardmodePrompt = (
      <div className="text-slate-500 mt-3 text-sm dark:text-gray-100">
        فعّل المستوى الصعب في نافذة الإعدادات
        <CogIcon className="h-5 w-5 cursor-pointer dark:stroke-white inline m-1"></CogIcon>
        لفرصة الحصول على 🥇.
      </div>
    )
  }
  return (
    <BaseModal title="أحسنت صنعاً" isOpen={isOpen} handleClose={handleClose}>
      <div>
        <div className="mx-auto flex items-center justify-center h-12 w-12 text-4xl">
          {isHardMode ? '🥇' : '🥈'}
        </div>
        {hardmodePrompt}
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title
            as="h3"
            className="text-lg leading-6 font-medium text-gray-900"
          >
            <ShowMeaning word={guesses[guesses.length - 1]}></ShowMeaning>
          </Dialog.Title>
          <div className="mt-2">
            <MiniGrid guesses={guesses} />
          </div>
        </div>
      </div>
      <NextWirdCountdown></NextWirdCountdown>
      <div className="mt-5 sm:mt-6">
        <button
          type="button"
          className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-semibold text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-bg "
          onClick={() => {
            shareStatus(guesses, false, isHardMode)
            handleShare()
          }}
        >
          {SHARE_TEXT}
        </button>
        <a
          href="https://www.buymeacoffee.com/alwird"
          target="_blank"
          rel="noreferrer"
        >
          <button
            type="button"
            className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-semibold text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm my-2.5"
          >
            {SUPPORT_US_TEXT}
          </button>
        </a>
      </div>
    </BaseModal>
  )
}
